import * as React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { selectCurrentUserIsViewOnly } from 'spw-redux/modules/projects/selectors';
import { colors } from 'spw-theme';

type Props = {
  iconPath: string;
  isSelected: boolean;
  disabled: boolean;
  onClick?: () => void;
};

const ImageWrapper = styled.div`
  && {
    width: 69px;
    height: 56px;
    box-sizing: border-box;
    cursor: pointer;
    border-radius: 4px;
    border: 1px solid ${colors.offWhite};
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &.selected {
    background: ${colors.backgroundGrey};
    border-color: ${colors.tableHeaderInnerBorderGray};
  }

  &.disabled {
    cursor: default;
    background-color: ${colors.lightGreyBackground};
    border-color: ${colors.lightGreyBackground};

    img {
      filter: invert(75%);
    }
  }

  &&:hover {
    background-color: ${colors.backgroundGrey};
  }
`;

export const OutlinedCardIcon = ({
  iconPath,
  isSelected,
  disabled,
  onClick,
}: Props) => {
  const currentUserIsViewOnly = useSelector(selectCurrentUserIsViewOnly);
  return (
    <ImageWrapper
      className={[
        isSelected ? 'selected' : '',
        disabled ? 'disabled' : '',
      ].join(' ')}
      onClick={
        currentUserIsViewOnly || disabled
          ? null
          : () => {
              if (onClick) onClick();
            }
      }
    >
      <img height={40} src={`/images/space-icons/${iconPath}.svg`} alt="" />
    </ImageWrapper>
  );
};
